import { render } from "./Ticket.vue?vue&type=template&id=5f11d840&scoped=true&lang=pug"
import script from "./Ticket.vue?vue&type=script&lang=ts"
export * from "./Ticket.vue?vue&type=script&lang=ts"

import "./Ticket.vue?vue&type=style&index=0&id=5f11d840&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5f11d840"

export default script